/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L10Inputs */

const en_mk_sec_pg_l10 = /** @type {(inputs: Mk_Sec_Pg_L10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Self-hosting`)
};

const id_mk_sec_pg_l10 = /** @type {(inputs: Mk_Sec_Pg_L10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemasangan di server sendiri (self-host)`)
};

/**
* | output |
* | --- |
* | "Self-hosting" |
*
* @param {Mk_Sec_Pg_L10Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l10 = /** @type {((inputs?: Mk_Sec_Pg_L10Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L10Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l10(inputs)
	return en_mk_sec_pg_l10(inputs)
});